module.exports = __webpack_public_path__ + "manifest.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/manifest.json
// module id = 371
// module chunks = 0